import React, { useState } from "react";
import { Alert, Table } from "react-bootstrap";

interface ResourceLinkState {
  resources: any[];
  formatHistoryDateTime: (dateString: string) => { date: string; time: string };
}

const ResourceLink = ({ resources, formatHistoryDateTime }: ResourceLinkState) => {
  const [showResources, setShowResources] = useState(false);
  const resourceCount = resources.map((r) => r.quantity).reduce((a, b) => a + b, 0);

  const onClickViewConsumables = () => {
    setShowResources((prev) => !prev);
  };

  return (
    <>
      <p
        className={showResources ? "d-flex justify-content-start text-secondary mb-0" : "d-flex justify-content-start text-secondary mb-5"}
      >
        <Alert.Link onClick={() => onClickViewConsumables()}>{resourceCount} Recent Consumable(s)</Alert.Link>
      </p>

      {showResources && (
        <Table striped className="mb-5">
          <thead>
            <tr>
              <th>Resource</th>
              <th>Category</th>
              <th>Quantity</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {resources.map((r: any, index: number) => {
              const formatted = formatHistoryDateTime(r.assigned_at ?? "");
              return (
                <tr key={index}>
                  <td>{r.resource_name}</td>
                  <td className="text-capitalize">{r.resource_category_name}</td>
                  <td>{r.quantity}</td>
                  <td>{`Assigned on ${formatted.date} at ${formatted.time}`}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default ResourceLink;
